import { useNavigate } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Clock, HeartHandshake } from 'lucide-react';
import MobileShell from '@/components/MobileShell';
import ResqlyMark from '@/components/resqly/ResqlyMark';
import ResqlyCard from '@/components/resqly/ResqlyCard';
import { Button } from '@/components/ui/button';

export default function RangerIntroduction() {
  const navigate = useNavigate();

  return (
    <div className="resqly-shell">
      <div className="resqly-frame flex flex-col min-h-screen min-h-[100dvh]">
        <MobileShell title="RESQLY Ranger" hideBack={false}>
          <div className="px-5 py-6 space-y-6" data-testid="ranger-introduction">
            <div className="text-center pt-2">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-blue-50 border border-blue-100 mb-4">
                <ResqlyMark size={40} />
              </div>
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">
                Provide care through RESQLY
              </h2>
              <p className="text-sm text-slate-600 mt-2 max-w-sm mx-auto leading-relaxed">
                RESQLY Rangers are verified partners who accept healthcare requests — doctors,
                nurses, caregivers, ambulance crews, and more.
              </p>
            </div>

            <ResqlyCard className="p-4 space-y-3" elevated>
              <Point
                icon={<HeartHandshake className="w-4 h-4 text-blue-700" />}
                text="Help people get care when they need it most."
              />
              <Point
                icon={<Clock className="w-4 h-4 text-blue-700" />}
                text="Work on your schedule — accept requests that fit you."
              />
              <Point
                icon={<ShieldCheck className="w-4 h-4 text-blue-700" />}
                text="Join a verified network built for safety and trust."
              />
            </ResqlyCard>

            <div className="space-y-3 pt-2">
              <Button
                data-testid="ranger-continue-auth"
                className="w-full h-12 rounded-xl bg-blue-700 hover:bg-blue-800 text-base font-semibold"
                onClick={() => navigate('/provider/login')}
              >
                Continue as Ranger
                <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
              <button
                type="button"
                onClick={() => navigate('/consumer/home')}
                className="w-full text-sm text-slate-500 py-2"
              >
                Back to home
              </button>
            </div>
          </div>
        </MobileShell>
      </div>
    </div>
  );
}

function Point({ icon, text }) {
  return (
    <div className="flex items-start gap-3 text-sm text-slate-700">
      <span className="mt-0.5 flex-shrink-0">{icon}</span>
      <span>{text}</span>
    </div>
  );
}
